import type { CreditConfirmationBlock } from "@containers/Hermes/types";
import ActionCardShell from "./ActionCardShell";

type CreditConfirmationCardProps = {
  block: CreditConfirmationBlock;
  onClose: () => void;
  // Sends the user's confirmation, with the card's token, as their next message.
  onConfirm?: (text: string, confirmToken: string) => void;
};

/**
 * The cost confirmation for a priced tariff lookup, opened in place of the
 * composer like the other action cards. Nothing has run or been charged until
 * the user confirms: the card's token goes back with their next message.
 */
export default function CreditConfirmationCard({ block, onClose, onConfirm }: CreditConfirmationCardProps) {
  const credits = `${block.credits} value add credit${block.credits === 1 ? "" : "s"}`;

  return (
    <ActionCardShell
      title={`Confirm ${block.label || "lookup"}`}
      primaryLabel={`Confirm (${block.credits} credits)`}
      busyLabel="Confirming"
      busy={false}
      primaryDisabled={!onConfirm}
      onPrimary={() => {
        onConfirm?.("Yes, go ahead.", block.confirm_token);
        onClose();
      }}
      onDiscard={onClose}
      footerNote={<span>{`This costs ${credits}`}</span>}>
      {block.summary ? <p className="tw-mt-3 tw-mb-0 tw-text-sm tw-text-gray-700">{block.summary}</p> : null}
    </ActionCardShell>
  );
}
